<div class="full-width" data-test="fix-now-banner" data-testid="fix-now-banner">
  <div class="content">
    <div class="header-container">
      <div class="status-container">
        <div class="status">Rejected</div>
      </div>
      <div class="icon-container">
        <mat-icon svgIcon="crossed" class="svg-icon" (click)="closeSheet('close')"></mat-icon>
      </div>
    </div>
    <div class="title-container">
      <div class="title" data-test="rejected-document-name" data-testid="rejected-document-name">{{ title }}</div>
    </div>
    <div class="reason-container">
      <div class="reason-text" data-testid="rejection-reason">
        {{ reason }}
      </div>
    </div>
    <div class="button-container">
      <button mat-raised-button type="submit" color="primary" class="save-button" (click)="closeSheet('fixNow')" data-test="fix-now-button" data-testid="fix-now-button">
        Fix Now
      </button>
    </div>
  </div>
</div>
